(() => {
  if (window.pfHeaderTransition) { window.pfHeaderTransition(); return; }
  let group, slot, frame = 0, resizeFrame = 0, compact = false;
  const apply = () => {
    frame = 0;
    if (!group) return;
    const next = window.scrollY > (compact ? 80 : 110);
    if (next === compact) return;
    compact = next;
    group.classList.toggle('pf-header-compact', compact);
    const wordmark = group.querySelector('.pf-compact-wordmark');
    if (wordmark) { wordmark.tabIndex = compact && innerWidth >= 1200 ? 0 : -1; wordmark.setAttribute('aria-hidden', String(!compact || innerWidth < 1200)); }
    const top = group.querySelector('.header--top-row');
    if (top) top.inert = compact && innerWidth >= 1200;
  };
  const measure = () => {
    if (!group || !slot) return;
    group.classList.add('pf-header-measuring');
    group.classList.remove('pf-header-compact');
    slot.style.setProperty('--pf-header-reserved', group.getBoundingClientRect().height + 'px');
    group.classList.toggle('pf-header-compact', compact);
    slot.classList.add('pf-header-ready');
    group.classList.remove('pf-header-measuring');
    const top = group.querySelector('.header--top-row');
    if (top) top.inert = compact && innerWidth >= 1200;
    const wordmark = group.querySelector('.pf-compact-wordmark');
    if (wordmark) { wordmark.tabIndex = compact && innerWidth >= 1200 ? 0 : -1; wordmark.setAttribute('aria-hidden', String(!compact || innerWidth < 1200)); }
  };
  const init = () => {
    group = document.querySelector('.layout--header-group');
    slot = group?.closest('.pf-header-slot');
    if (!slot) return;
    compact = false;
    measure();
    apply();
  };
  window.pfHeaderTransition = init;
  addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(apply); }, {passive:true});
  addEventListener('resize', () => { cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(measure); }, {passive:true});
  addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
  init();
  document.fonts?.ready.then(measure);
})();